import { connect } from 'react-redux';
import { injectIntl as withIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import { pushPage } from '@shared/actions';
import trackProductSearchClicked from '@conversion/tracking/actions/trackProductSearchClicked';
import filterMenu from '@core/reducers/menu/actions/filterMenu';
import getMenuSections from '@shopDetails/selectors/getMenuSections';
import getFilterMenu from '@core/reducers/menu/selectors/getFilterMenu';
import closeOnlinePaymentTooltip from '@shopDetails/actions/closeOnlinePaymentTooltip';
import getExtendedMenuSelectedSection from '@shopDetails/selectors/getExtendedMenuSelectedSection';
import extendedMenuSectionChanged from '@shopDetails/actions/extendedMenuSectionChanged';
import trackSectionClicked from '@shopDetails/tracking/actions/trackSectionClicked';
import { getShopBusinessType } from '@shopDetails/selectors';
import trackMenuSection from '@shopDetails/tracking/actions/trackMenuSection';
import getCartIsPickUp from '@core/reducers/cart/selectors/getCartIsPickUp';
import ExtendedMenuHeader from './ExtendedMenuHeader';

const mapStateToProps = createStructuredSelector({
  menuFilterSearch: getFilterMenu,
  menuSections: getMenuSections,
  selectedSection: getExtendedMenuSelectedSection,
  businessType: getShopBusinessType,
  isPickUp: getCartIsPickUp,
});

const mapDispatchToProps = {
  pushPage,
  trackProductSearchClicked,
  filterMenu,
  closeOnlinePaymentTooltip,
  extendedMenuSectionChanged,
  trackSectionClicked,
  trackMenuSection,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withRouter, withConnect, withIntl)(ExtendedMenuHeader);
